import React, { Component, Suspense } from "react";
import { connect } from "react-redux";
import { GlobalStyle } from "./style";
import {FullScreenLoading} from "../../components/loading";
import ResponsiveFix from "../../components/responsiveFix";
class Index extends Component {
  render() {
    const { Component, route } = this.props;
    return (
      <ResponsiveFix>
        <GlobalStyle />
        <Suspense fallback={<FullScreenLoading/>}>
          <Component route={route} />
        </Suspense>
      </ResponsiveFix>
    );
  }
}

export default connect()(Index);
